<div class="container mt-5 lg:mt-0" style="max-width: 1360px">
  <div class="row">
    <div
      class="menu-account col-3 hidden lg:block"
      [ngClass]="{ 'menu-account-min': menuCollapsed }"
    >
      <div class="account-nav">
        <!-- <div class="container-bar clearfix">
            <div class="logo-company text-center col p-0"></div>
            <div class="button-menu pointer" (click)="changeMenu()">
              <i class="fas fa-bars"></i>
            </div>
          </div> -->
        <ul>
          <li
            *ngFor="let link of links"
            class="account-nav__item"
            routerLinkActive="account-nav__item--active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a
              class="min"
              tooltip="{{ link.label }}"
              [routerLink]="link.url"
              [ngClass]="{ 'btn-dark': link.dark }"
            >
              <i class="{{ link.icon }} me-3"></i>
            </a>

            <a
              class="large"
              [routerLink]="link.url"
              [ngClass]="{ 'btn-dark': link.dark }"
            >
              <i class="{{ link.icon }} me-3 dimension"></i>
              <span class="text">
                {{ link.label | titlecase }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12 lg:col-9 py-0 p-0">
      <router-outlet></router-outlet>
      <div style="margin-bottom: 70px !important"></div>
    </div>
  </div>
</div>

<!-- ANTERIOR  -->

<!-- <div class="container mt-5 lg:mt-0" style="max-width: 1360px">
  <div class="row flex-nowrap">
    <div class="flex">
      <div
        class="menu-account hidden lg:block"
        [ngClass]="{ 'menu-account-min': menuCollapsed }"
      >
        <div class="account-nav flex-grow-1">
          <div class="flex container-bar">
            <div class="logo-company text-center col p-0"></div>
            <div class="button-menu pointer" (click)="changeMenu()">
              <i class="fas fa-bars"></i>
            </div>
          </div>
          <ul>
            <li
              *ngFor="let link of links"
              class="account-nav__item"
              routerLinkActive="account-nav__item--active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <a
                class="min"
                tooltip="{{ link.label }}"
                [routerLink]="link.url"
                [ngClass]="{ 'btn-dark': link.dark }"
              >
                <i class="{{ link.icon }} me-3"></i>
              </a>

              <a
                class="large"
                [routerLink]="link.url"
                [ngClass]="{ 'btn-dark': link.dark }"
              >
                <i class="{{ link.icon }} me-3 dimension"></i>
                <span class="text">
                  {{ link.label | titlecase }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col py-0 p-0">
        <router-outlet></router-outlet>
        <div style="margin-bottom: 70px !important"></div>
      </div>
    </div>
  </div>
</div> -->
